module.exports = __webpack_public_path__ + "static/media/upload_headers_popup_sample_data.0ce1913c.png";